import apiClient from './api';

/**
 * Service pour gérer les comptes non administrés
 */
export const nonManagedAccountsService = {
  /**
   * Récupérer les comptes non administrés d'un domaine
   * @param {number} domainId - ID du domaine
   * @param {Object} options - Options de recherche et pagination
   * @param {string} options.search - Terme de recherche
   * @param {number} options.page - Page courante
   * @param {number} options.pageSize - Taille de la page
   * @returns {Promise<Array>} Liste des comptes formatés pour React Select
   */
  getNonManagedAccounts: async (domainId, options = {}) => {
    try {
      const { search = '', page = 1, pageSize = 100 } = options;
      
      const response = await apiClient.get(
        `/api/accounts/domain/${domainId}/non-managed`,
        { 
          params: { 
            search, 
            page, 
            pageSize 
          } 
        }
      );
      
      if (response.data.success) {
        // Formater les données pour React Select
        return response.data.data.map(account => ({
          value: account.id,
          label: `${account.displayName} - ${account.email || 'Pas d\'email'}`,
          data: account // Garder les données complètes pour usage futur
        }));
      }
      
      throw new Error('Réponse API invalide');
      
    } catch (error) {
      console.error('Erreur lors du chargement des comptes non administrés:', error);
      throw error;
    }
  },

  /**
   * Recherche asynchrone pour React Select (avec debounce intégré)
   * @param {number} domainId - ID du domaine
   * @param {string} inputValue - Valeur de recherche
   * @param {Function} callback - Callback pour retourner les options
   */
  loadOptions: (domainId) => async (inputValue, callback) => {
    try {
      const options = await nonManagedAccountsService.getNonManagedAccounts(domainId, {
        search: inputValue,
        pageSize: 50
      });
      callback(options);
    } catch (error) {
      console.error('Erreur recherche comptes:', error);
      callback([]);
    }
  },

};

export default nonManagedAccountsService;